import { buildVideoObject } from '~/composables/seo/videoSchemaBuilder'

export function useSettingVideoSEO({
    key,
    title,
    description,
    contentUrl,
    thumbnailUrl,
}: {
    key: string
    title: string
    description: string
    contentUrl: string
    thumbnailUrl: string
}) {
    const videoObject = computed(() =>
        buildVideoObject({
            name: title,
            description,
            contentUrl,
            thumbnailUrl,
            encodingFormat: 'video/mp4',
        })
    )

    return useHead(
        computed(() => ({
            script: videoObject.value
                ? [
                    {
                        key: key,
                        type: 'application/ld+json',
                        innerHTML: JSON.stringify(videoObject.value),
                    },
                ]
                : [],
        }))
    )
}

 
